import api from './axios';
import DOMPurify from 'dompurify';

const { REACT_APP_API_BASE } = process.env;

//단일파일 업로드시 사용
export const uploadFileUtil = async (formData) => {
  const response = await api.post('/knouComm/api/ncpOS/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      //   onUploadProgress: (progressEvent) => {
      //   const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      //   setUploadProgress(percent);
      // },
    });
  return response.data;
};

//멀티파일 업로드시 사용
export const uploadMultiFileUtil = async (formData) => {
  const response = await api.post('/knouComm/api/ncpOS/uploadFiles', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

//멀티파일 업로드시 사용
export const sendEmailUtil = async (formData) => {
  const response = await api.post('/knouComm/api/ncpEmail/sendSampleMail', formData);
  return response.data;
};

//멀티파일 업로드시 사용
export const testLms = async (params) => {
  const response = await api.get('/knouLms/api/lms/eduLecture/contentsGroupList', params);
  return response.data;
};

//파일 업로드 - lms 전송후 uuid 응답
export const uploadFileLmsSend = async (formData) => {
  // const response = await api.post('/nouLms/api/lms/files/upload', formData, {
  const response = await api.post('/knouUser/api/files/upload', formData, {
        headers: { 
          'Content-Type': 'multipart/form-data' 
        },
    });
  return response.data;
};

//다운로드
export const downloadFile = (path, fileName) => {
  const url = REACT_APP_API_BASE+`/knouComm/api/ncpOS/download?path=${encodeURIComponent(path)}&fileName=${encodeURIComponent(fileName)}`;

  window.location.href = url;
};

export const cleanHtml = (text) => {
  const clean = DOMPurify.sanitize(text, {
        USE_PROFILES: { html: true },
      })
    return clean;
}

// 검색 스니펫은 서버가 만든 mark 만 허용한다.
export const cleanSearchHtml = (text) => DOMPurify.sanitize(text ?? '', {
  ALLOWED_TAGS: ['mark'],
  ALLOWED_ATTR: [],
});

//브라우저 체크
export function getDeviceInfo() {
  const ua = navigator.userAgent;

  // ===== 모바일 여부 =====
  const isMobile = /Android|iPhone|iPad|iPod|Mobile/i.test(ua);

  // ===== OS =====
  let os = "Unknown";

  if (/Windows NT 10\.0/i.test(ua)) os = "Windows 10/11";
  else if (/Windows NT 6\.3/i.test(ua)) os = "Windows 8.1";
  else if (/Windows NT 6\.1/i.test(ua)) os = "Windows 7";
  else if (/Mac OS X/i.test(ua)) os = "Mac OS";
  else if (/Android/i.test(ua)) os = "Android";
  else if (/iPhone|iPad|iPod/i.test(ua)) os = "iOS";
  else if (/Linux/i.test(ua)) os = "Linux";

  // ===== 브라우저 =====
  let browser = "Unknown";

  if (/Edg/i.test(ua)) browser = "Edge";
  else if (/Chrome/i.test(ua)) browser = "Chrome";
  else if (/Safari/i.test(ua) && !/Chrome/i.test(ua)) browser = "Safari";
  else if (/Firefox/i.test(ua)) browser = "Firefox";
  else if (/OPR|Opera/i.test(ua)) browser = "Opera";
  else if (/MSIE|Trident/i.test(ua)) browser = "IE";

  return {
    os,
    browser,
    isMobile,
    device: isMobile ? "Mobile" : "PC",
    userAgent: ua
  };
}